import { CONVEYANCE_TYPES } from "@koala/sdk";
import { Component } from "react";
import { type ConnectedProps, connect } from "react-redux";
import { DeliveryModalStateContainer } from "./deliveryManager";
import { PickupConfirm } from "@/components/fulfillmentManager/pickupManager";
import GenericModal from "@/components/uielements/genericModal";
import { MODAL } from "@/constants/events";
import conveyanceModeActions from "@/redux/conveyanceMode/actions";
import globalActions from "@/redux/global/actions";
import { type RootState } from "@/types/app";
import { getOpeningElement, clearOpeningElement } from "@/utils/focusReturn";

class FulfillmentManager extends Component<ReduxProps> {
  componentDidUpdate(prevProps: ReduxProps) {
    // Return focus when modal closes
    if (
      prevProps.fulfillmentModal.display &&
      !this.props.fulfillmentModal.display
    ) {
      const openingElement = getOpeningElement();
      if (openingElement && document.contains(openingElement)) {
        // Use requestAnimationFrame to ensure the modal is fully closed
        requestAnimationFrame(() => {
          if (openingElement && document.contains(openingElement)) {
            openingElement.focus();
          }
        });
      } else {
        console.log("Opening element not found or not in DOM");
      }
      clearOpeningElement();
    }
  }

  render() {
    const {
      toggleFulfillmentModal,
      fulfillmentModal,
      checkDeliveryAddress,
      basketFulfillment,
      deliveryAddressValidating,
    } = this.props;

    if (!fulfillmentModal.display) {
      return null;
    }

    return (
      <GenericModal
        modalOpen={fulfillmentModal.display}
        toggleModal={toggleFulfillmentModal}
        disableModalClose={fulfillmentModal.disableModalClose}
        name={MODAL.FULFILLMENT_MANAGER}
        aria-labelledby={
          fulfillmentModal.type === CONVEYANCE_TYPES.DELIVERY
            ? "modal-header"
            : undefined
        }
        enableFocusTrap={fulfillmentModal.type === CONVEYANCE_TYPES.DELIVERY}
      >
        {/* Display Pickup Manager */}
        {fulfillmentModal.type === CONVEYANCE_TYPES.PICKUP && <PickupConfirm />}
        {/* Display Delivery Manager */}
        {fulfillmentModal.type === CONVEYANCE_TYPES.DELIVERY && (
          <DeliveryModalStateContainer
            checkDeliveryAddress={checkDeliveryAddress}
            toggleFulfillmentModal={toggleFulfillmentModal}
            fulfillmentModal={fulfillmentModal}
            basketFulfillment={basketFulfillment}
            deliveryAddressValidating={deliveryAddressValidating}
            // @ts-expect-error ensure that `revalidate` isn't null.
            revalidate={fulfillmentModal.revalidate}
          />
        )}
      </GenericModal>
    );
  }
}

const mapStateToProps = (state: RootState) => ({
  basketFulfillment: state.app.basket.fulfillment,
  deliveryAddressValidating: state.app.conveyanceMode.loading,
  fulfillmentModal: state.app.global.fulfillmentModal,
});

const mapDispatchToProps = {
  toggleFulfillmentModal: globalActions.toggleFulfillmentModal,
  checkDeliveryAddress: conveyanceModeActions.checkDeliveryAddress,
};

const connector = connect(mapStateToProps, mapDispatchToProps);
type ReduxProps = ConnectedProps<typeof connector>;
export default connector(FulfillmentManager);
